import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import PrivateRoute from './Utils/PrivateRoute';
import AdminPanel from './Components/AdminComp/adminpanel';
import SignIn from './Components/LoginComp/signin';
import SignUp from './Components/LoginComp/signup';
import Body from './Components/BodyComp/body';
import NavComp from './Components/MainComp/NavComp';
import FooterComp from './Components/MainComp/FooterComp';
import ContactUs from './Components/ContactComp/contactus';
import AboutUs from './Components/AboutComp/aboutus';
import Event from './Components/EventComp/event';
import Appointment from './Components/AppointmentComp/appointment';
import Gallery from './Components/GalleryComp/gallery';
import SangaProfile from './Components/AboutComp/sangaprofile';
import UserProfile from './Components/UserComp/userprofile';
import AlmsOffering from './Components/UserComp/almsoffering';
import ForgotPassword from './Components/LoginComp/ForgotPassword';
import WhatsAppButton from './Components/Whatsapp/WhatsAppButton';
import Monastery from './Components/UserComp/monastery';
import DhammaPada from './Components/DhammaPadaComp/dhammapada';

// import AwuruduSeason from './Components/awurudu/awurudu';

import LoadingScreen from './Components/LoadingComp/LoadingScreen';
import AramaPoojava from './Components/AramaPoojavaComp/arama-poojava';



function App() {


    const [isLoading, setIsLoading] = useState(true);
  const [hasShownLoading, setHasShownLoading] = useState(false);

  useEffect(() => {
    // Check if loading screen has been shown before (using sessionStorage)
    const loadingShown = sessionStorage.getItem('loadingShown');
    
    if (loadingShown) {
      setHasShownLoading(true);
      setIsLoading(false);
      return;
    }

    // Show loading screen for 3 seconds minimum
    const timer = setTimeout(() => {
      setIsLoading(false);
      sessionStorage.setItem('loadingShown', 'true');
    }, 3000);

    // Also hide when page is fully loaded
    window.addEventListener('load', () => {
      clearTimeout(timer);
      setIsLoading(false);
      sessionStorage.setItem('loadingShown', 'true');
    });

    return () => {
      clearTimeout(timer);
      window.removeEventListener('load', () => {});
    };
  }, []);


  return (
    <Router>
       {isLoading && !hasShownLoading && <LoadingScreen />}
      <NavComp />
      <Routes>
        <Route path="/" element={<Body />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/sangaprofile" element={<SangaProfile />} />
        <Route path="/event" element={<Event />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/appointment" element={<Appointment />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path='/almsoffering' element={<AlmsOffering />} />
        <Route path="/ForgotPassword" element={<ForgotPassword />} />
        <Route path="/monastery" element={<Monastery />} />
        <Route path="/dhammapada" element={<DhammaPada />} />
        <Route path="/arama-poojava" element={<AramaPoojava />} />
        

        <Route
          path="/userprofile"
          element={
            <PrivateRoute>
                <UserProfile />
            </PrivateRoute>
          }
        />

                    
                     
        
                <Route
          path="/adminpanel"
          element={
            <PrivateRoute>
              <AdminPanel />
            </PrivateRoute>
          }
        />
      </Routes>
      <FooterComp />
      <WhatsAppButton /> 
      {/* <AwuruduSeason /> */}
    </Router>
  );
}

export default App;





